export const ENVIRONMENT = {
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as unknown as string,
  SENTRY_AUTH_TOKEN: import.meta.env.VITE_SENTRY_AUTH_TOKEN as unknown as string,
  ENV: import.meta.env.VITE_APP_ENVIRONMENT as unknown as string,
  ENABLE_DEBUG: import.meta.env.VITE_ENABLE_DEBUG === 'true',
  DOMAIN_NAME: (import.meta.env.VITE_DOMAIN_NAME ?? '') as unknown as string,
};
